import * as firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyAMSsz4b7XOTDWYhgmppcWVPxUX2DRMy4E",
    authDomain: "compdes2018-5dcda.firebaseapp.com",
    databaseURL: "https://compdes2018-5dcda.firebaseio.com",
    projectId: "compdes2018-5dcda",
    storageBucket: "compdes2018-5dcda.appspot.com",
    messagingSenderId: "490149005048"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

export default firebaseApp;



// WEBPACK FOOTER //
// ./src/app/firebaseConnection.js